import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";

const COPY = {
  live: {
    overline: "Coming soon — Phase II",
    title: "Live salons.",
    body: "Cook alongside a chef in Lyon. Wander a flea market in Saint-Ouen with a stylist. Sit in on an editor's notebook session at Café de Flore. Live broadcasts from our members and the editors of Belle Inspiration, with chat, hearts, and replays.",
    img: "https://images.unsplash.com/photo-1505159940484-eb2b9f2588e2?w=1600&q=85",
    quote: "\"The best evenings begin with: come over, je cuisine.\"",
  },
  marketplace: {
    overline: "Coming soon — Phase III",
    title: "The Boutique.",
    body: "A curated marketplace for members to sell their finds — vintage glassware from the brocante, hand-bound notebooks, original paintings, antique linens, small-batch perfume. Monetized beautifully, with Belle Inspiration's curation.",
    img: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=1600&q=85",
    quote: "\"The most beautiful things have a quiet history.\"",
  },
  events: {
    overline: "Coming soon",
    title: "Members' events.",
    body: "Private dinners, magazine launches, viewing parties for the network. A calendar lives here.",
    img: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1600&q=85",
    quote: "\"Set the table for eight, and let the evening decide.\"",
  },
  default: {
    overline: "Coming soon",
    title: "This room is being prepared.",
    body: "We are gathering the right things, the right people, and the right light. Return shortly.",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=1600&q=85",
    quote: "\"Some rooms reveal themselves slowly.\"",
  },
};

const ComingSoon = ({ section }) => {
  const c = COPY[section] || COPY.default;
  return (
    <div data-testid={`coming-${section}`} className="app-shell">
      <Navbar />
      <div className="container-belle" style={{ paddingTop: 110, paddingBottom: 80 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" }} className="coming-grid">
          <div>
            <div className="overline" style={{ color: "var(--brand-accent)" }}>{c.overline}</div>
            <h1 className="editorial-h1" style={{ fontSize: "clamp(44px, 6vw, 84px)", marginTop: 14, marginBottom: 28 }}>
              {c.title}
            </h1>
            <p className="editorial-body" style={{ fontSize: 18, marginBottom: 32 }}>{c.body}</p>
            <div className="pull-quote font-serif" style={{ fontSize: 22, color: "var(--text-primary)" }}>{c.quote}</div>
            <div style={{ marginTop: 40, display: "flex", gap: 12 }}>
              <Link to="/feed" className="btn-primary" style={{ textDecoration: "none" }}>Back to the salon</Link>
            </div>
            <p className="overline" style={{ marginTop: 40, opacity: 0.65 }}>We will write when the doors open.</p>
          </div>
          <div className="media-zoom" style={{ overflow: "hidden", aspectRatio: "3/4" }}>
            <img src={c.img} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        </div>
      </div>
      <Footer />
      <style>{`@media (max-width: 768px) { .coming-grid { grid-template-columns: 1fr !important; gap: 40px !important; } }`}</style>
    </div>
  );
};

export default ComingSoon;
